/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type FilterValueSchemaScope = typeof FilterValueSchemaScope[keyof typeof FilterValueSchemaScope] | null;


export const FilterValueSchemaScope = {
  c: 'c',
  p: 'p',
  cp: 'cp',
} as const;
